export default __webpack_public_path__ + "static/media/contact_home.98f2cb70.svg";